export function LabelTaskForm({ children }: { children: React.ReactNode }) {
    return (
        <label className="text-gray-600 font-medium">
            { children }
        </label>
    );
}